module.exports = __webpack_public_path__ + "img/user-2.b4e3a29b.jpg";